import { IconRefresh } from '../icons.js';
import type { SecretWord } from './secretWords.js';

/**
 * Tarjeta de la PALABRA SECRETA (juego `describe-it`): banner persistente bajo
 * el header mientras el juego está activo. La palabra es client-only (el coach
 * no la ve — la adivina en serio); esta tarjeta es la única forma en que el
 * user la conoce. "Otra palabra" reparte una nueva y re-pivotea al coach
 * (nueva ronda).
 */
interface SecretWordCardProps {
  word: SecretWord;
  onReroll: () => void;
  /** Sesión terminada: el re-roll re-envía el seed por WS → sería un no-op. */
  disabled?: boolean;
}

export function SecretWordCard({ word, onReroll, disabled = false }: SecretWordCardProps) {
  return (
    <div
      className="secret-word-card"
      style={{ '--dir-color': '#f783ac' } as React.CSSProperties}
      role="status"
      aria-live="polite"
    >
      <div className="secret-word-body">
        <span className="secret-word-tag">
          <SecretGlyph size={13} />
          Tu palabra secreta
        </span>
        <span className="secret-word-word">
          {word.en}
          <span className="secret-word-es">· {word.es}</span>
        </span>
        <span className="secret-word-hint">
          Describila en inglés sin decirla — el coach no la ve y adivina en serio.
        </span>
      </div>
      <button
        type="button"
        className="secret-word-reroll"
        onClick={onReroll}
        disabled={disabled}
        aria-label="Repartir otra palabra secreta"
      >
        <IconRefresh size={13} />
        Otra
      </button>
    </div>
  );
}

function SecretGlyph({ size = 13 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 12 C 5.6 7.6, 18.4 7.6, 21 12 C 18.4 16.4, 5.6 16.4, 3 12 Z" />
      <circle cx="12" cy="12" r="2.3" fill="currentColor" stroke="none" />
      <path d="M5 19.5 L 19 4.5" />
    </svg>
  );
}
